<template>
    <svg :style="`width: ${width}; height: ${height};`"
         width="25"
         height="20"
         viewBox="0 0 25 20"
         xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14.139.398l9.815 5.657c.565.326.89.822.89 1.362 0 .54-.325 1.036-.89 1.361l-1.815 1.046a.74.74 0 0 1-1.006-.262.724.724 0 0 1 .266-.996l1.814-1.045a.612.612 0 0 0 .139-.104.616.616 0 0 0-.14-.104l-9.814-5.657c-.472-.272-1.33-.272-1.802 0L1.78 7.313a.624.624 0 0 0-.14.104.62.62 0 0 0 .14.104l9.815 5.656c.472.273 1.333.274 1.805.003l4.486-2.571a1.261 1.261 0 0 0-.168-.118l-4.473-2.614-.883.5a.501.501 0 0 1-.672-.172l-1.656-2.68a.489.489 0 0 1 .018-.541.501.501 0 0 1 .51-.198l4.68.97a.491.491 0 1 1 .145.91l-.686.388 3.762 2.181c.93.54 1.633 1.752 1.633 2.82v2.228c0 1.069-.704 2.28-1.637 2.818l-4.34 2.5c-.46.266-1.05.399-1.642.399-.59 0-1.181-.133-1.642-.398L6.497 17.1c-.933-.538-1.637-1.75-1.637-2.818V10.98L1.04 8.778C.475 8.453.15 7.956.15 7.417c0-.54.325-1.036.89-1.362L10.855.398c.92-.53 2.363-.53 3.284 0zm0 14.041c-.46.264-1.048.395-1.638.395-.592 0-1.185-.133-1.646-.399l-4.523-2.607v2.455c0 .543.432 1.287.906 1.56l4.34 2.501c.47.272 1.33.272 1.802 0l4.339-2.501c.474-.273.906-1.017.906-1.56v-2.228a1.21 1.21 0 0 0-.015-.178l-4.47 2.562z"
            :fill="color"
            fill-rule="evenodd"
        />
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            required: false,
            default: 'currentColor',
            type: String,
        },
        width: {
            required: false,
            default: 'auto',
            type: [Number, String],
        },
        height: {
            required: false,
            default: '1em',
            type: [Number, String],
        },
    },
};
</script>
